module.exports = __webpack_public_path__ + "img/sup_kyc_1.96d28347.jpg";